<template>
  <svg width="53"
       height="52"
       viewBox="0 0 53 52"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.0485 49.8334L23.0248 32.6953L7.97254 49.8334H1.60449L20.1995 28.6674L1.60449 2.16675H17.954L29.2863 18.3193L43.4851 2.16675H49.8531L32.121 22.3525L51.398 49.8334H35.0485ZM42.14 45.0018H37.8528L10.7226 6.99841H15.0104L25.8763 22.2153L27.7552 24.8558L42.14 45.0018Z"
          fill="currentColor" />
  </svg>
</template>
